export default class ChangedDocumentStatusDialogViewModel {
  current_status = 1;

  total_steps = 3;

  steps = [
    'ChangedDocumentStatusDocumentReceived',
    'ChangedDocumentStatusNeedSignature',
    'ChangedDocumentStatusSendToAllianz',
  ];

  change_of_documents_requests_status: Record<string, number> = {
    PROOF_ON_VALIDATION: 1,
    PROOF_VALIDATED: 1,
    SIGNATURE_REQUESTED: 2,
    REQUEST_SEND: 3,
    REQUEST_APPROVED: 3,
  }

  current_component = this.steps[this.current_status - 1];

  initialize = (status: string) => {
    this.setDefaultComponent(status);
  }

  setDefaultComponent = (status: string) => {
    if (this.change_of_documents_requests_status[status]) {
      this.current_status = this.change_of_documents_requests_status[status];
      this.current_component = this.steps[this.current_status - 1];
    }
  }

  showMenuDivider = (step: number) => (step < this.total_steps)
}
